import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"display":"flex","align-items":"center","flex-direction":"row","flex-wrap":"wrap","gap":"4px","justify-content":"center"} }
const _hoisted_4 = { style: {"color":"#fff","font-size":"0.85em","margin":"16px 0 8px 0","text-align":"center"} }
const _hoisted_5 = {
  key: 1,
  style: {"display":"flex","gap":"8px","align-items":"flex-start"}
}
const _hoisted_6 = { style: {"display":"flex","gap":"4px","align-items":"center","flex-direction":"column"} }
const _hoisted_7 = {
  key: 0,
  style: {"font-size":"24px"}
}
const _hoisted_8 = { style: {"flex":"1"} }
const _hoisted_9 = { style: {"margin":"0","font-size":"0.8em","line-height":"1.2"} }
const _hoisted_10 = {
  key: 3,
  style: {"margin-top":"8px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_badge = _resolveComponent("ion-badge")!

  return (_openBlock(), _createElementBlock("div", {
    class: "program-content",
    style: _normalizeStyle([{"width":"100%","display":"flex","flex-direction":"column","gap":"4px","padding":"5px 0"}, { 'min-height': '50px' }])
  }, [
    ($props.fromDeckView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!$props.hideNames)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_ion_button, {
                    class: "no-text-transform",
                    size: "small",
                    color: "primary",
                    style: {"margin":"0","height":"36px","font-size":"0.95em"},
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($props.item?.programWebsite ? $setup.openBrowser($props.item?.programWebsite) : undefined), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($props.item?.institutionNameShort), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    size: "small",
                    color: "primary",
                    style: {"margin":"0","height":"36px","font-size":"0.95em"},
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($props.item?.jupasUrl ? $setup.openBrowser($props.item?.jupasUrl) : undefined), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($props.item?.jupasCode), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", _hoisted_4, _toDisplayString($props.item?.name), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            ($props.idx != null)
              ? (_openBlock(), _createElementBlock("b", _hoisted_7, _toDisplayString($setup.getBandLabel($props.idx)), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_icon, {
              size: "large",
              icon: $setup.ellipse,
              color: $props.targetScoreIconColor || 'danger'
            }, null, 8, ["icon", "color"]),
            _createVNode(_component_ion_icon, {
              size: "large",
              icon: $setup.star,
              color: $props.schoolPredictScoreIconColor || 'danger'
            }, null, 8, ["icon", "color"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString($props.item.jupasCode), 1),
            _createElementVNode("small", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString($props.item.label), 1)
            ])
          ])
        ])),
    ($props.showRecommendedEvents)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: _normalizeStyle({ 'padding-left': $props.fromDeckView ? '0' : '48px' })
        }, [
          _createVNode(_component_ion_item, {
            lines: "full",
            button: "",
            detail: "",
            color: "fdmtred"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("p", { style: {"margin":"0","color":"#fff"} }, "HK$300k per awardee scholarship", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ], 4))
      : _createCommentVNode("", true),
    (!$props.hideDisciplineBadges)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...new Set($props.item.disciplines.map(d => d.groupName))], (groupName) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "badges-scroll-container",
              key: groupName
            }, [
              _createVNode(_component_ion_badge, {
                style: _normalizeStyle({ '--background': $setup.getDisciplineGroupColor(groupName), fontSize: '0.75em' })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(groupName), 1)
                ]),
                _: 2
              }, 1032, ["style"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.disciplines.filter(d => d.groupName === groupName), (discipline) => {
                return (_openBlock(), _createBlock(_component_ion_badge, {
                  key: discipline.id,
                  style: _normalizeStyle({ '--background': $setup.getDisciplineGroupColor(discipline.groupName, true), fontSize: '10.4px', padding: '0 3px', height: '13px' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(discipline.name), 1)
                  ]),
                  _: 2
                }, 1032, ["style"]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}